module.exports = __webpack_public_path__ + "static/media/logo-color.4e5308f2.png";